import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AvailableBillGatewayAppsModel, Benefit } from '../../models/available-bill-gateway-apps.model';
import { PlatformService } from '../../services/platform.service';
import { PaymentService, PersonalData } from '../../services/payment.service';
import { PaymentTypeEnum } from '../../models/payment-type.model';

@Component({
  selector: 'app-moje-uslugi-payment-dialog',
  templateUrl: './bill-gateway-app-dialog.component.html',
  styleUrls: ['./bill-gateway-app-dialog.component.scss']
})
export class BillGatewayAppDialogComponent implements OnInit {
  Benefit = Benefit;
  platform: 'desktop' | 'android' | 'ios';
  mobileAppAvailable: boolean;
  redirectLink: string;
  page: 'value_proposition' | 'instructions' = 'value_proposition';

  constructor(
    @Inject(MAT_DIALOG_DATA) readonly data: BillGatewayAppDialogData,
    private platformService: PlatformService,
    private paymentService: PaymentService,
    private dialogRef: MatDialogRef<BillGatewayAppDialogComponent>
  ) {}

  ngOnInit(): void {
    this.platform = this.platformService.platform;
    this.mobileAppAvailable =
      !!this.data.billGatewayApp.redirectLink.ios || !!this.data.billGatewayApp.redirectLink.android;
  }

  submit() {
    if (this.page === 'instructions' || !this.data.billGatewayApp.hasInstructions) {
      this.paymentService.redirectToBillGatewayApp({
        connectApp: this.data.billGatewayApp.code,
        paymentType: this.data.paymentType,
        personalData: this.data.personalData
      });
    } else {
      this.page = 'instructions';
    }
  }
}

export interface BillGatewayAppDialogData {
  token: string;
  paymentType: PaymentTypeEnum;
  personalData: PersonalData;
  biller: string;
  billGatewayApp: AvailableBillGatewayAppsModel;
}
